module.exports = __webpack_public_path__ + "images/search/empty-facility-agent.jpg";